import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import '@/i18n'
import '@/index.css'
import App from './App'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { ChatBotProvider } from '@/contexts/ChatBotContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <CookieConsentProvider>
          <ChatBotProvider>
            <App />
          </ChatBotProvider>
        </CookieConsentProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)
